import RentalInformationRoute from './rental-information.jsx'

export default RentalInformationRoute;